/* eslint-disable indent */
import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'
import { Box } from '@chakra-ui/react'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
  color?: string
}

const QuestionWithNotificationIconOutline = createIcon({
  displayName: 'QuestionWithNotificationIconOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path d="M0,24H24V0H0Z" fill="none" />
      {/* <path
        d="M20.76929,10A9.02818,9.02818,0,1,1,14,3.23071"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      /> */}
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        fill="none"
        d="M12 21v0c-4.971 0-9-4.029-9-9v0c0-4.971 4.029-9 9-9v0c4.971 0 9 4.029 9 9v0c0 4.971-4.029 9-9 9Z"
      ></path>
      {/* <circle cx="19" cy="5" r="2" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /> */}
      <path
        d="M14.4,10.15038A2.29663,2.29663,0,0,0,11.98086,8,2.34428,2.34428,0,0,0,9.6,9.81241"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.4,10.15039h0a2.08582,2.08582,0,0,1-1.07284,1.82333L12,12.71106"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.10014,15.90013A.1.1,0,1,1,12,15.8a.1.1,0,0,1,.10013.10013"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const QuestionWithNotificationIconFilled = createIcon({
  displayName: 'QuestionWithNotificationIconFilled',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path d="M0,24H24V0H0Z" fill="none" />
      <path
        d="M20.76929,10A9.02818,9.02818,0,1,1,14,3.23071"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="circle"
        cx="19"
        cy="5"
        r="2"
        fill="red.500"
        stroke="red.500"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.4,10.15038A2.29663,2.29663,0,0,0,11.98086,8,2.34428,2.34428,0,0,0,9.6,9.81241"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.4,10.15039h0a2.08582,2.08582,0,0,1-1.07284,1.82333L12,12.71106"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M12.10014,15.90013A.1.1,0,1,1,12,15.8a.1.1,0,0,1,.10013.10013"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const QuestionWithNotification: FC<CustomIconProps> = (props) => {
  switch (props.variant) {
    case 'filled':
      return <CustomIcon as={QuestionWithNotificationIconFilled} {...props} />
    default:
      return <CustomIcon as={QuestionWithNotificationIconOutline} {...props} />
  }
}

export default memo(QuestionWithNotification)
